import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Apple = function Apple(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.981 0C11.041 2.127 9.52 3.603 8 3.51 7.75 1.814 9.52 0 10.981 0zM1.44 8.65c0 2.475 1.97 7.336 4.35 7.35h.017c.591 0 1.113-.195 1.575-.367l.004-.001c.338-.127.658-.247.91-.247.499 0 .8.128 1.15.277.346.147.738.314 1.292.314 2.265 0 3.825-4.198 3.825-4.393 0-.299-.227-.436-.447-.568l-.002-.001c-.5-.301-1.54-.927-1.54-2.552 0-1.373.919-2.066 1.422-2.446l.353-.266-.245-.368c-1.046-1.57-2.785-1.696-3.358-1.696h-.005c-.768 0-1.428.263-1.958.474l-.01.004c-.246.097-.521.206-.64.206-.199 0-.558-.132-.905-.26-.496-.183-1.058-.39-1.585-.39-1.17 0-4.203.886-4.203 4.93z",
    fill: "currentColor"
  }));
};
export default Apple;